module.exports = __webpack_public_path__ + "img/bgEn.e5e27a5f.png";